import React from 'react';
import styles from './style.module.css';

interface RecognitionCardProps {
  image: string;
  title: string;
  text: string;
  date: string;
  url?: string;
  showURL?: boolean;
}

const RecognitionCard: React.FC<RecognitionCardProps> = ({ image, title, text, date, url, showURL }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);

  return (
    <>
    <div className={styles['recognition-1-card']} onClick={() => setIsOpen(true)}>
      <img src={image} alt={title} className={styles['card-image']} />
      <h3 className={styles['card-title']}>{title}</h3>
      {date ? <p className={styles['card-date']}>{date}</p> : <></>}
      <div
          className={styles['card-text']}
          dangerouslySetInnerHTML={{ __html: text }}
      />
      {(url && showURL) && (
        <a href={url} target="_blank" rel="noopener noreferrer" className={styles['card-link']}>
          Read more →
        </a>
      )}
    </div>

    {isOpen && (
        <div className={styles['modal-overlay']} onClick={() => setIsOpen(false)}>
          <div className={styles['modal-content']} onClick={e => e.stopPropagation()}>
            <button className={styles['close-button']} onClick={() => setIsOpen(false)}>×</button>
            
            { !imageLoaded ?
              
                <div className={styles['slot-loading']}>
                  <p className="card-text placeholder-wave">
                    <span className="placeholder col-12"></span>
                  </p>
                </div>
                :
                <></>
              
            }
            <img src={image} alt={title} className={styles['modal-image']}
                loading='eager' onLoad={() => { console.log("loaded"); setImageLoaded(true) }}
                style={{ display: imageLoaded ? 'block' : 'none' }}

              />
            <h2 className={styles['modal-title']}>{title}</h2>
            <p className={styles['modal-date']}>{date}</p>
            <div
              className={styles['modal-text']}
              dangerouslySetInnerHTML={{ __html: text }}
            />
            {url && (
              <a href={url} target="_blank" rel="noopener noreferrer" className={styles['modal-link']}>
                Read full article →
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default RecognitionCard;
